import PageRequest from "@/api/Main/dataSource/api/pagination-helper/lib/PageRequest";
import GetListByProjectIdRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/GetListByProjectIdRequest";
import GetListByProjectIdResponse from "@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/GetListByProjectIdResponse";
import AddQueueRelationRequest from "@/api/Main/dataSource/api/projects/task/i-service/models/task/request/AddQueueRelationRequest";
import RemoveQueueRelationRequest from "@/api/Main/dataSource/api/projects/task/i-service/models/task/request/RemoveQueueRelationRequest";
import {
  NamespaceRelationModel,
  QueueRelationGroupModel,
  QueueRelationModel,
  QueueRelationParentTaskModel,
  UserModel,
} from "@/components/task-forms/models";
import { PaginationResponseModel } from "@/models";

export const mapGetQueuesRequest = (
  projectId: number,
  filter: { Search: string; Skip: number; Take: number },
) =>
  new GetListByProjectIdRequest({
    ProjectId: projectId,
    Search: filter.Search,
    Page: new PageRequest({
      Skip: filter.Skip,
      Take: filter.Take,
    }),
  });

export const mapGetQueuesResponse = (response: GetListByProjectIdResponse, projectId: number) =>
  new PaginationResponseModel<QueueRelationModel[]>({
    Items: response.Items.map(
      (item) =>
        new QueueRelationModel({
          Id: item.QueueTaskId,
          Name: item.QueueTaskName,
          Namespace: new NamespaceRelationModel({
            Id: item.Namespace?.Id,
            Name: item.Namespace?.Name,
            Color: item.Namespace?.Color,
            Icon: item.Namespace?.IconUrl,
          }),
          ParentTask: item.ParentTask
            ? new QueueRelationParentTaskModel({
                TaskId: item.ParentTask.TaskId,
                NamespaceId: item.ParentTask.NamespaceId,
                QueueId: item.ParentTask.QueueTaskId,
                ProjectId: projectId,
                Author: new UserModel({
                  Id: item.ParentTask.UserImage.OwnerId,
                  FirstName: item.ParentTask.UserImage.FirstName,
                  LastName: item.ParentTask.UserImage.LastName,
                  MiddleName: item.ParentTask.UserImage.MiddleName,
                  AvatarColor: item.ParentTask.UserImage.AvatarColor,
                  ImageUrl: item.ParentTask.UserImage.Foto,
                }),
                Access: item.AccessParentTask,
              })
            : undefined,
          Groups: item.GroupPatch?.map(
            (group) =>
              new QueueRelationGroupModel({
                Id: group.Id,
                Name: group.Name,
              }),
          ),
        }),
    ),
    Count: response.Page.Count,
  });

export const mapAddQueueRelationRequest = (taskId: number, queueId: string) =>
  new AddQueueRelationRequest({
    TaskId: taskId,
    QueueTaskId: queueId,
  });

export const mapRemoveQueueRelationRequest = (taskId: number, queueId: string) =>
  new RemoveQueueRelationRequest({
    TaskId: taskId,
    QueueTaskId: queueId,
  });
